import Styles from './LmsCertificate.module.scss';
import { useAPI } from 'components/lib';
import { useRef, useEffect } from 'react';

/**
 * Generates a certificate for a user.
 * @param {string} courseId id of the particular course.
 */
export function LmsCertificate({ courseId, onReady, ...props }) {
    // eslint-disable-next-line no-unused-vars
    const { data } = useAPI(`/api/lms/course/${courseId}/certificate/details`);
    const fullName = data?.first_name + " " + data?.last_name;

    // Convert the date format
    function formatDate(dateString) {
        if (dateString && dateString?.length) {
            const date = new Date(dateString);
            const options = { day: 'numeric', month: 'long', year: 'numeric' };
            return date.toLocaleDateString('en-US', options);
        }
    }
    const dateString = data?.competed_date;
    const formattedDate = formatDate(dateString);
    const companyLogo = data?.company_logo;
    const companyLogoUrl = companyLogo ?
        `${process.env.REACT_APP_GLOBAL_MEDIA_URL}/${companyLogo}`
        : `${process.env.REACT_APP_GLOBAL_MEDIA_URL}/topos-icons/global/aivagam_logo.jpg`
    const topgrepLogoUrl = `${process.env.REACT_APP_GLOBAL_MEDIA_URL}/topos-icons/global/tgtlogo.png`

    const isProdEnv = process.env.REACT_APP_PRODUCTION;
    const readyCalledRef = useRef(false);
    useEffect(() => {
        if (readyCalledRef.current) return;
        if (!fullName || fullName.trim().toLowerCase() === 'undefined undefined' || fullName.trim() === 'null') {
            return
        };

        requestAnimationFrame(() => {

            if (typeof onReady === 'function') {
                onReady();
            }
            readyCalledRef.current = true;
        });
    }, [fullName, props]);


    return (
        <div className={Styles.container}>
            {/* Watermark */}
            {isProdEnv !== "true" && (
                <img
                    src={`${process.env.REACT_APP_GLOBAL_MEDIA_URL}/topos-icons/global/certificate_watermark.png`}
                    alt="Watermark"
                    className={Styles.watermark}
                    crossOrigin="anonymous"
                />
            )}
            {/* Background decorative elements */}
            <div className={Styles.backgroundLeft}></div>
            <div className={Styles.backgroundRight}></div>
            <div className={Styles.topBorder}></div>
            <div className={Styles.bottomBorder}></div>
            {/* Decorative corners */}
            <div className={Styles.cornerTopLeft}></div>
            <div className={Styles.cornerTopRight}></div>
            <div className={Styles.cornerBottomLeft}></div>
            <div className={Styles.cornerBottomRight}></div>

            <div className={Styles.logoContainer}>
                <img
                    src={companyLogoUrl}
                    alt="Organization Logo"
                    className={Styles.orgLogo}
                    crossOrigin="anonymous"
                />
            </div>
            <div className={Styles.dateSection}>
                    <p className={Styles.dateLabel}>Date of Completion</p>
                    <p className={Styles.certificateDate}>{formattedDate}</p>
                </div>

            {/* Header Section */}
            <div className={Styles.headerSection}>
                <h1 className={Styles.certificateTitle}>CERTIFICATE</h1>
                <div className={Styles.titleUnderline}></div>
                <p className={Styles.ofCompletion}>OF COMPLETION</p>
            </div>

            {/* Main content */}
            <div className={Styles.mainContent}>
                <p className={Styles.presentedTo}>This is to certify that</p>

                <div className={Styles.nameSection}>
                    <h2 className={Styles.recipientName}>{data?.last_name ? fullName : data?.first_name}</h2>
                    <div className={Styles.nameUnderline}></div>
                </div>

                <p className={Styles.achievementText}>has successfully completed the course</p>

                <div className={Styles.courseSection}>
                    {/* <div className={Styles.courseBox}> */}
                    <h3 className={Styles.courseName}>{data?.course_name}</h3>
                    {/* </div> */}
                </div>

                <p className={Styles.recognitionText}>
                    {data?.company_name} recognizes this achievement and commitment to professional excellence.
                </p>
            </div>

            {/* Bottom section with logo and date */}
            <div className={Styles.credentialsSection}>
                <div className={Styles.logoSection}>
                    <div className={Styles.signatureDetails}>
                        <p className={Styles.signatureLabel}>Powered by </p>
                    </div>
                    <img
                        src={topgrepLogoUrl}
                        alt="Organization Logo"
                        className={Styles.tgorgLogo}
                        crossOrigin="anonymous"
                    />
                </div>


                {/* Decorative elements */}
                <div className={Styles.decorativeShape}></div>
                <div className={Styles.sidePattern}></div>
            </div>

            <div className={Styles.signatureSection}>
                <div className={Styles.signatureDetails}>
                    <p className={Styles.signatureName} aria-label={`Applicant: ${fullName}`}>
                        {data?.last_name ? fullName : data?.first_name}
                    </p>
                    <p className={Styles.signatureLine}></p>
                    <p className={Styles.signatureLabel}>Recipient Signature</p>
                </div>
                <div className={Styles.signatureDetails}>
                    <p className={Styles.signatureName} aria-label={`Issuer: ${data?.company_name}`}>
                        {data?.company_name}
                    </p>
                    <p className={Styles.signatureLine}></p>
                    <p className={Styles.signatureLabel}>Issuer Signature</p>
                </div>
            </div>
        </div>
    );
}
